import React from "react";

export default function AttentionIcon({ color = "#000000" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="58"
      height="58"
      viewBox="0 0 58 58"
      fill="none"
    >
      <path
        d="M53,44V27.5C53,17.299,44.698,9,34.494,9H23.506C13.302,9,5,17.299,5,27.5V44H0v2h6h1h3v2c0,0.552,0.447,1,1,1h3h2h1h2h3c0.553,0,1-0.448,1-1v-2h12v2c0,0.552,0.447,1,1,1h3h2h1h2h3c0.553,0,1-0.448,1-1v-2h3h1h6v-2H53z M21,47h-2v-3h-2v3h-1v-3h-2v3h-2v-1v-1c0-1.103,0.899-2,2.006-2h4.988C20.101,43,21,43.897,21,45v1V47z M46,47h-2v-3h-2v3h-1v-3h-2v3h-2v-1v-1c0-1.103,0.899-2,2.006-2h4.988C45.101,43,46,43.897,46,45v1V47z M47.858,44c-0.448-1.72-2.002-3-3.864-3h-4.988c-1.861,0-3.416,1.28-3.864,3H22.858c-0.448-1.72-2.003-3-3.864-3h-4.988c-1.861,0-3.416,1.28-3.864,3H7V27.5C7,18.402,14.404,11,23.506,11h10.988C43.596,11,51,18.402,51,27.5V44H47.858z"
        fill={color}
      />

      <path
        d="M21,26c-3.309,0-6,2.691-6,6v1h2v-1c0-2.206,1.794-4,4-4c1.025,0,1.951,0.398,2.66,1.034C22.719,29.197,22,30.014,22,31c0,1.103,0.897,2,2,2c0.366,0,0.705-0.106,1-0.278V33h2v-1C27,28.691,24.309,26,21,26z"
        fill={color}
      />

      <path
        d="M39,26c-3.309,0-6,2.691-6,6v1h2v-1c0-2.206,1.794-4,4-4c1.025,0,1.951,0.398,2.66,1.034C40.719,29.197,40,30.014,40,31c0,1.103,0.897,2,2,2c0.366,0,0.705-0.106,1-0.278V33h2v-1C45,28.691,42.309,26,39,26z"
        fill={color}
      />
    </svg>
  );
}
